<div *ngIf="showCard" id="card-container" data-testid="notification-card" [class]="cardClass">
  <div id="content-block">
    <ng-content select="[header]"></ng-content>
    <ng-content select="[body]"></ng-content>
  </div>

  <div id="action-block">
    <ng-content select="[action-button]"></ng-content>
    <fa-icon id="close-icon" [icon]="faTimes" (click)="onClickCross()"></fa-icon>
  </div>
</div>
